import { track } from "../track";

export const trackAvatarPhotoUploadTry = () =>
  track({ event: "avatar_photo_upload_try" });
